<template>
  <div class="layout settings-layout">
    <SettingsNav/>
    <router-view/>
  </div>
</template>

<script>
import '@/assets/css/modules/_settings.scss';

import SettingsNav from '@/components/settings/SettingsNav';

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'SettingsLayout',
  components: {
    SettingsNav,
  },
};
</script>
